
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gamification",
      function () {
        return require("private-next-pages/gamification/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gamification"])
      });
    }
  